// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"ea8b84a40ae7e77c","5405":"e4a4a183f01c5abb"}[chunkId] + ".css";
};